<script setup>
defineProps({
  title: {
    type: String,
    default: () => '',
  },
  value: {
    type: String,
    default: () => '',
  },
  backgroundColor: {
    type: String,
    default: () => '',
  },
  view: {
    type: String,
    default: () => '',
  },
});
</script>
<template>
  <div
    class="info-stat-card"
    :class="`info-stat-card--${backgroundColor} info-stat-card--${view}`"
  >
    <div class="info-stat-card__wrap">
      <p
        v-if="value"
        class="mb-0 info-stat-card__value h3"
        v-html="value"
      ></p>
      <div
        v-if="title"
        class="info-stat-card__title body-3-bold"
        v-html="title"
      ></div>
    </div>
  </div>
</template>
<style scoped lang="scss">
@use 'sass:math';
.info-stat-card {
  $parent: &;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 128px;
  text-align: center;
  &--white {
    background-color: $gray;
  }
  &--black {
    background-color: rgba($surface-container-opacity, 0.5);
    #{$parent} {
      &__value {
        color: $white;
      }
      &__title {
        color: $white;
      }
    }
  }
  &--gray {
    background-color: $white;
  }
  &--top {
    justify-content: flex-start;
    min-height: 96px;
    padding: 24px 16px 21px;
  }
  &--centered {
    justify-content: center;
    padding: 16px;
  }
  @include media-breakpoint-up(sm) {
    &--top {
      padding: 32px 24px 29px;
    }
    &--centered {
      padding: 24px;
    }
  }
  @include media-breakpoint-up(md) {
    &--top {
      padding: 32px 24px 29px;
    }
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(border-radius, 8);
    @include responsive-spacing(gap, 48);
    @include responsive-spacing(padding, 24);
    @include responsive-spacing(min-height, 128);
    &--top {
      @include responsive-spacing(padding-top, 32);
      @include responsive-spacing(padding-bottom, 29);
      @include responsive-spacing(padding-right, 24);
      @include responsive-spacing(padding-left, 24);
    }
  }
  &__wrap {
    align-self: center;
    display: flex;
    flex-direction: column;
    gap: 8px;
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 8);
    }
  }
  &__value {
    margin: 0;
    color: $black;
  }
  &__title {
    color: $on-surface-variant-2;
  }
}
</style>
